import { createAxios } from '../lib/axiosFactory';
import { errorParser } from '../lib/response/errorParser';
import { AppSettings } from '../../shared/lib/interfaces/appSettings';

export const state = {};

export const getters = {
  appSettings: (state: AppSettings): AppSettings => {
    return state;
  }
};

export const actions = {
  async loadAppSettings({ commit, state }) {
    try {
      const response = await createAxios().get(
        'backend/public-app-settings-show'
      );

      const { versionNumber, maintenanceMode } = response.data.data.attributes;

      commit('setAppSettings', {
        versionNumber,
        maintenanceMode
      });

      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async getAppSettings({ commit, state }, fields) {
    try {
      const response = await createAxios().get('backend/app-settings-show', {
        params: {
          'fields[appSettings]': fields ?? 'optOutSettings'
        }
      });
      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};

export const mutations = {
  setAppSettings(state: AppSettings, { versionNumber, maintenanceMode }) {
    if (maintenanceMode && !this.getters['user/isInternalUser']) {
      state.versionNumber = versionNumber;
      state.maintenanceMode = maintenanceMode;
      window.location.href = '/maintenance';
      return;
    }

    if (state.versionNumber && state.versionNumber !== versionNumber) {
      const toastNotification = {
        message:
          'A new and improved version of the application is now available.',
        duration: 3000,
        type: 'success',
        button: {
          text: 'Refresh',
          link: '/'
        }
      };

      this.commit('components/toast/addNotification', toastNotification, {
        root: true
      });
    }

    state.versionNumber = versionNumber;
    state.maintenanceMode = maintenanceMode;
  }
};
